import moment from 'moment'

export const createOfferDatePreset = (minutes, now = Date.now()) => ({
  from: new Date(now - minutes * 60000).toISOString(),
  to: new Date(now).toISOString()
})

export const getOfferDateBounds = range => {
  if (!range || typeof range !== 'object') return null
  const readBound = value => {
    if (typeof value !== 'string' || !value) return NaN
    return moment(value, moment.ISO_8601, true).valueOf()
  }
  const from = readBound(range.from)
  const to = readBound(range.to)
  return Number.isFinite(from) && Number.isFinite(to) && to >= from
    ? { from, to }
    : null
}

export const getOfferDateRangeFields = range => {
  const bounds = getOfferDateBounds(range)
  return {
    fromDate: bounds ? moment(bounds.from).format('YYYY-MM-DD') : '',
    fromTime: bounds ? moment(bounds.from).format('HH:mm') : '',
    toDate: bounds ? moment(bounds.to).format('YYYY-MM-DD') : '',
    toTime: bounds ? moment(bounds.to).format('HH:mm') : ''
  }
}

export const getOfferDateRangeFromFields = fields => {
  const names = ['fromDate', 'fromTime', 'toDate', 'toTime']
  if (names.every(name => !fields[name])) return 'all'
  const readBound = name => {
    const date = fields[`${name}Date`]
    const time = fields[`${name}Time`]
    if (!date || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time || '')) return null
    const input = `${date} ${time}`
    const format = 'YYYY-MM-DD HH:mm'
    const value = moment(input, format, true)
    // Include the whole final minute, so 23:59 reaches the end of the day.
    return value.isValid() && value.format(format) === input
      ? (name === 'to' ? value.endOf('minute') : value).toISOString()
      : null
  }
  const range = { from: readBound('from'), to: readBound('to') }
  return getOfferDateBounds(range) ? range : null
}

export const completeOfferDateRange = (fields, now = Date.now()) => {
  const names = ['fromDate', 'fromTime', 'toDate', 'toTime']
  if (names.every(name => !fields[name])) return { fields, range: 'all' }

  const today = moment(now).format('YYYY-MM-DD')
  const fromDate = fields.fromDate || today
  const toDate = fields.toDate || today
  const completedFields = {
    ...fields,
    fromDate,
    toDate,
    fromTime: fields.fromTime || '00:00',
    toTime: fields.toTime || (fromDate === toDate ? '23:59' : '00:00')
  }
  return {
    fields: completedFields,
    range: getOfferDateRangeFromFields(completedFields)
  }
}

export const getOfferAddedAtTime = offer => {
  const source = offer.offer || offer
  const raw = source.raw || {}
  // Publication can be later than the original creation of the offer.
  const addedAt = [
    raw.addedToListingAt,
    source.addedToListingAt,
    raw.createdAt,
    source.createdAt
  ].find(value => value != null && value !== '')
  if (addedAt == null) return NaN
  return typeof addedAt === 'number' ? addedAt : Date.parse(addedAt)
}

export const filterOffersByAddedAt = (offers, range) => {
  const bounds = getOfferDateBounds(range)
  if (!bounds) return offers
  return offers.filter(offer => {
    const addedAt = getOfferAddedAtTime(offer)
    return (
      Number.isFinite(addedAt) && addedAt >= bounds.from && addedAt <= bounds.to
    )
  })
}
